import {
  BabyCenterLogo,
  BestMoneyLogo,
  BusinessInsiderLogo,
  ChimeLogo,
  CreditKarmaLogo,
  ForbesLogo,
  ForbesUsaTodayLogo,
  FundComLogo,
  GoodRxLogo,
  InsuranceRankedLogo,
  JoyWalletLogo,
  MarketWatchLogo,
  MoneyTalksNewsLogo,
  MoneyWiseLogo,
  MoonshotLogo,
  NeighborhoodAlertsLogo,
  NewForbesLogo,
  PerkSpotLogo,
  SoFiLogo,
  SpotowerLogo,
  VoicedMediaLogo,
  WhatToExpectLogo,
} from '@/icons'

import { useCreditKarmaHeader } from './useCreditKarmaHeader'
import { useForbesHeaderNavbar } from './useForbesHeaderNavbar'
import useGetCobrandingNewPartner, {
  CobrandingNewPartners,
} from './useGetCobrandingNewPartners'
import { useIsSofi } from './useIsSofi'
import { useNewForbesCobranding } from './useNewForbesCobranding'

const useCheckCobrandingNewPartnersLogos = (
  currentPartnerLogo: JSX.Element | null | undefined = null
) => {
  // 1 shared pathname with different utm_terms
  let cobrandedPartner = useGetCobrandingNewPartner()

  // Unique path
  const isCreditKarma = useCreditKarmaHeader()

  // 2 pathnames with same utm_term
  const isForbes = useForbesHeaderNavbar()
  const isNewForbes = useNewForbesCobranding()

  const isSofi = useIsSofi()

  if (isCreditKarma) {
    cobrandedPartner = CobrandingNewPartners.CreditKarma
  }
  if (isForbes && !isNewForbes) {
    cobrandedPartner = CobrandingNewPartners.Forbes
  }
  if (isNewForbes) {
    cobrandedPartner = CobrandingNewPartners.NewForbes
  }
  if (isSofi) {
    cobrandedPartner = CobrandingNewPartners.Sofi
  }

  let partnerLogo = currentPartnerLogo

  switch (cobrandedPartner) {
    case CobrandingNewPartners.Sofi:
      partnerLogo = <SoFiLogo />
      break
    case CobrandingNewPartners.Forbes:
      partnerLogo = <ForbesLogo />
      break
    case CobrandingNewPartners.NewForbes:
      partnerLogo = <NewForbesLogo />
      break
    case CobrandingNewPartners.CreditKarma:
      partnerLogo = <CreditKarmaLogo />
      break
    case CobrandingNewPartners.BestMoney:
      partnerLogo = <BestMoneyLogo />
      break
    case CobrandingNewPartners.ForbesUsaToday:
      partnerLogo = <ForbesUsaTodayLogo />
      break
    case CobrandingNewPartners.BabyCenter:
      partnerLogo = <BabyCenterLogo />
      break
    case CobrandingNewPartners.BusinessInsider:
      partnerLogo = <BusinessInsiderLogo />
      break
    case CobrandingNewPartners.Chime:
      partnerLogo = <ChimeLogo />
      break
    case CobrandingNewPartners.FundCom:
      partnerLogo = <FundComLogo />
      break
    case CobrandingNewPartners.InsuranceRanked:
      partnerLogo = <InsuranceRankedLogo />
      break
    case CobrandingNewPartners.JoyWallet:
      partnerLogo = <JoyWalletLogo />
      break
    case CobrandingNewPartners.MoneyTalksNews:
      partnerLogo = <MoneyTalksNewsLogo />
      break
    case CobrandingNewPartners.MoneyWise:
      partnerLogo = <MoneyWiseLogo />
      break
    case CobrandingNewPartners.Moonshot:
      partnerLogo = <MoonshotLogo />
      break
    case CobrandingNewPartners.PerkSpot:
      partnerLogo = <PerkSpotLogo />
      break
    case CobrandingNewPartners.Spotower:
      partnerLogo = <SpotowerLogo />
      break
    case CobrandingNewPartners.VoicedMedia:
      partnerLogo = <VoicedMediaLogo />
      break
    case CobrandingNewPartners.WhatToExpect:
      partnerLogo = <WhatToExpectLogo />
      break
    case CobrandingNewPartners.GoodRX:
      partnerLogo = <GoodRxLogo />
      break
    case CobrandingNewPartners.MarketWatch:
      partnerLogo = <MarketWatchLogo />
      break
    case CobrandingNewPartners.NeighborhoodAlerts:
      partnerLogo = <NeighborhoodAlertsLogo />
      break
    default:
      partnerLogo = currentPartnerLogo
      break
  }

  return partnerLogo
}

export default useCheckCobrandingNewPartnersLogos
